<template>
    <div id="composeContainer" v-if="gamemaster">
        <div v-if="media === 'email'" id="selectAccount" :style="compact ? 'margin-bottom: 0.5em' : ''">
            <div style="margin-right: 0.5em;" v-if="!compact">{{ $t("communication.account") }}</div>
            <div class="emailInitial" :data-letters="sendToAccount ? sendToAccount[0] : ''" :style="random_color" />
            <input v-model="sendToAccount" :placeholder="$t('communication.sender')" type="text"
                class="customInput itemInput" style="background-color: #FFF; margin-left: 1em;" />
        </div>
        <div v-else id="selectAccount" :style="compact ? 'margin-bottom: 0.5em' : ''">
            <select v-model="selectedAccount" @change="checkCustom" class="userSelect">
                <option value="random" :disabled="no_names">{{ $t("communication.generatedUser") }}</option>
                <option value="custom" v-if="!compact">Custom</option>
                <option value="bt">B.T.</option>
                <option value="eb">Ekstra Bladet</option>
                <option value="jp">Jyllands-Posten</option>
                <option value="politiken">Politiken</option>
                <option value="borsen">Børsen</option>
                <option value="berlingske">Berlingske</option>
                <option value="mette">Mette Frederiksen</option>
                <option value="anon">Anonymous</option>
                <option value="quest">Quest</option>
            </select>
        </div>
        <div v-if="customInput">
            <div class="customSection">
                <div class="customSubheader">{{ $t("communication.name") }}</div>
                <input v-model="customName" type="text" class="customInput itemInput">
            </div>
            <div class="customSection">
                <div class="customSubheader">@</div>
                <input v-model="customHandle" type="text" class="customInput itemInput">
            </div>
            <div class="customSection">
                <div class="customSubheader">Verified</div>
                <input v-model="customVerified" type="checkbox" class="customInput itemInput">
            </div>
        </div>
        <div class="timeline-Tweet" id="tweetContainer">
            <div class="timeline-Tweet-brand button" v-show="selectedAccount == 'random'" @click="queueUser">
                <i class="fas fa-random" />
            </div>
            <div id="accountPreview" v-show="selectedAccount">
                <div v-show="media != 'email'"
                    :class="[{ Avatar: media == 'twitter', fbpProfileImg: media == 'facebook' || media == 'email' }, 'composeAvatar']"
                    :style="avatar" style="margin-right: 0.5em" />
                <div v-show="media != 'email'" id="accountTags">
                    <div id="accountName">
                        {{ account_name }}
                        <span v-if="media == 'twitter' && verified" class="Icon Icon--verified" />
                        <img v-else-if="media == 'facebook' && verified" src="/img/facebook-verified.png" />
                    </div>
                    <div id="accountHandle">@{{ account_handle }}</div>
                </div>
                <div id="accountReplying" @click="clearReplying" v-show="replying_to && media != 'email'">
                    <span style="color: #8899A6; margin-right: 0.25em">{{ $t('communication.replying') }}</span>
                    <span style="color: #1B95E0">@{{ replying_to_name }}</span>
                </div>
                <div class="emailReceiver" v-show="media == 'email'" v-if="!queue_only">
                    <div id="sendToSelectText">{{ $t("communication.for") }}:</div>
                    <DropdownCheck :items="pgroups_select" v-model="selected_pgroups" ref="pgroupSelect" />
                </div>
            </div>
            <textarea v-model="text" :maxlength="media == 'twitter' ? 280 : null" id="inputTweet"
                :placeholder="$t('communication.placeholder')" />
            <div style="display: flex">
                <span v-if="media == 'twitter'" style="margin-top:auto;">{{ text.length }}/280</span>
                <!-- Email upload -->
                <!-- <div v-if="media === 'email'" style="margin: 1em 1em auto 0; cursor: pointer;" @click="$refs.fileUpload.click()">
                    <input type="checkbox" ref="fileUpload"/>
                    Fil besvarelse
                </div> -->
                <div id="tweetCompose">
                    <div :class="[{ disabledButton: empty }, 'tweetButton']" @click="checkNames">
                        {{ queue_only ? 'Tilføj' :
                            media == 'twitter' ? 'Tweet' :
                                media == 'facebook' ? 'Post' :
                                    media == 'email' ? 'Send' :
                                        media == 'upload' ? 'Upload' : null }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div id="composeParent" v-else>
        <div class="timeline-TweetList-tweet">
            <div class="timeline-Tweet" id="tweetContainer">
                <div id="accountPreview">
                    <div v-if="media != 'email'"
                        :class="[{ Avatar: media == 'twitter', fbpProfileImg: media == 'facebook' || media == 'email' }, 'composeAvatar']"
                        :style="avatar" style="margin-right: 0.5em" />
                    <div class="emailInitial" style="margin:0" v-if="media == 'email'"
                        :data-letters="sendToAccount ? sendToAccount[0] : ''" :style="random_color" />

                    <div v-if="media != 'email'" id="accountTags">
                        <div id="accountName">
                            {{ pgroup_name }}
                            <span v-if="media == 'twitter'" class="Icon Icon--verified" />
                            <img v-else-if="media == 'facebook'" src="/img/facebook-verified.png" />
                        </div>
                        <div id="accountHandle">@{{ pgroup_name.replace(' ', '').toLowerCase() }}</div>
                    </div>
                    <div id="accountReplying" @click="clearReplying" v-show="replying_to">
                        <span style="color: #8899A6; margin-right: 0.25em">${{ $t('communication.replying') }}</span>
                        <span style="color: #1B95E0">@{{ replying_to_name }}</span>
                    </div>
                    <div style="display: flex; margin-left: auto" v-show="media == 'email'">
                        <div style="margin-left:0.2em" id="sendToSelectText">{{ $t('communication.for') }}</div>
                        <input v-model="sendToAccount" :placeholder="$t('communication.receiver')" type="text"
                            class="customInput itemInput" />
                    </div>
                </div>
                <textarea v-model="text" :maxlength="media == 'twitter' ? 280 : null" id="inputTweet"
                    :placeholder="$t('communication.placeholder')" />
                <div style="display:flex;">
                    <span v-if="media == 'twitter'" style="margin-top:0.5em;">{{ text.length }}/280</span>
                    <div :class="[{ disabledButton: empty }, 'tweetButton']" @click="sendMessage(null, false)">
                        {{ media == 'twitter' ? 'Tweet' :
                            media == 'facebook' ? 'Post' :
                                media == 'email' ? 'Send' :
                                    media == 'upload' ? 'Upload' : null }}
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { mapState } from 'vuex';
import { accounts, randomUsers } from '../global/accounts';
import DropdownCheck from './DropdownCheck';

import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);
export default {
    name: 'PostCompose',
    components: {
        DropdownCheck
    },
    props: {
        instance_id: Number,
        compact: {
            type: Boolean,
            default: false
        },
        queue_only: Boolean,
        gamemaster: Boolean,
        pgroup_id: Number,
        pgroup_name: String
    },
    data() {
        return {
            text: "",
            selectedAccount: "",
            sendToAccount: "",
            sendToGroup: null,
            customInput: false,
            customName: "",
            customHandle: "",
            customVerified: true,
            names: [],
            queuedUser: {
                account_name: "",
                account_handle: "",
                image_url: ""
            },
            replying_to: null,
            replying_to_name: "",
            selected_pgroups: []
        }
    },
    watch: {
        selectedAccount() { // Emit selected account (gamemaster only) to update avatar in Facebook comment boxes (dashboard)
            this.emitSelected()
        },
        text() {
            this.$emit('textChange', this.text)
        },
        media(val) { // Clear replying in compose textbox when switching from Twitter tab
            if (val != 'twitter')
                this.clearReplying()
        }
    },
    created() {
        this.getNames()
        this.selectedAccount = 'politiken' // Defined on created to trigger watch function
    },
    computed: {
        ...mapState([
            'ICOLORS',
            'curr_project'
        ]),
        ...mapState({
            gamemaster_id: state => state.gamemaster.gamemaster_id
        }),
        empty() {
            return this.text == "" ||
                this.selectedAccount == "" ||
                (this.customInput ? (this.customName == "" || this.customHandle == "") : false) ||
                (this.media == 'email' && this.sendToAccount == "")
        },
        image_url() {
            if (Object.keys(accounts).includes(this.selectedAccount))
                return accounts[this.selectedAccount].image_url
            else if (this.selectedAccount == 'random')
                return this.queuedUser.image_url
            else return null
        },
        avatar() {
            if (this.gamemaster) {
                if (Object.keys(accounts).includes(this.selectedAccount))
                    return 'background-image: url(' + accounts[this.selectedAccount].image_url + ')'
                else if (this.selectedAccount == 'random')
                    return 'background-image: url(' + this.queuedUser.image_url + ')'
                else return ''
            }
            else {
                if (this.media == 'facebook')
                    return 'background-image: url(/img/facebook-default.jpg)'
                else return ''
            }
        },
        account_name() {
            if (Object.keys(accounts).includes(this.selectedAccount))
                return accounts[this.selectedAccount].account_name
            else if (this.selectedAccount == 'random')
                return this.queuedUser.account_name
            else if (this.selectedAccount == 'custom')
                return this.customName
            return ''
        },
        account_handle() {
            if (Object.keys(accounts).includes(this.selectedAccount))
                return accounts[this.selectedAccount].account_handle
            else if (this.selectedAccount == 'random')
                return this.queuedUser.account_handle
            else if (this.selectedAccount == 'custom')
                return this.customHandle
            return ''
        },
        verified() {
            if (Object.keys(accounts).includes(this.selectedAccount)) return true
            else if (this.selectedAccount == 'random') return false
            else if (this.selectedAccount == 'custom') return this.customVerified
            return false
        },
        no_names() { return this.names.length == 0 },
        media() { return !this.queue_only ? this.$parent.tab : this.$parent.post_type },
        pgroups_select() { return !this.queue_only ? this.$parent.pgroups.map(p => ({ id: p.pgroup_id, label: p.name })) : null },
        random_color() {
            const random = Math.floor(Math.random() * this.ICOLORS.length);
            return 'border-radius: 50%; background-color: ' + this.ICOLORS[random] + ';'
        }

    },
    methods: {
        fillInput(obj) {
            this.text = obj.text
            this.selectedAccount = Object.values(accounts).find(v => v.account_handle == obj.account_handle)[0]
        },
        emitSelected() {
            this.$emit('selectedAccount', {
                avatar: this.avatar,
                image_url: this.image_url,
                name: this.account_name,
                handle: this.account_handle,
                verified: this.verified
            })
        },
        replyTo(post_id, author_handle) {
            this.replying_to = post_id
            this.replying_to_name = author_handle
        },
        clearReplying() {
            this.replying_to_name = ""
            this.replying_to = null
        },
        async getNames() {
            this.names = await randomUsers()
            this.queueUser()
        },
        checkNames() {
            if (this.empty) return
            if (this.names.length < 1)
                this.getNames().then(() => { this.checkNames() })
            else if (this.media == "email") {
                this.selected_pgroups.forEach(pg => this.sendMessage(pg, true))
                this.clearReplying()
                this.clearInput()
            }
            else this.sendMessage()
        },
        queueUser() {
            this.queuedUser = this.names.pop()
            this.emitSelected()
        },
        createPayload(pgroup_id) {
            const text = this.replying_to ? '@' + this.replying_to_name + ' ' + this.text : this.text
            const payload = {
                project_id: this.curr_project,
                instance_id: this.instance_id,
                gamemaster_id: this.gamemaster_id,
                parent_post_id: this.replying_to,
                text: text,
                sender: 'gamemaster',
                verified: true,
                queued: this.queue_only,
                type: this.media,
                pgroup_id: pgroup_id ? pgroup_id : (this.pgroup_id ? this.pgroup_id : null)
            }

            if (this.media == 'email') {
                payload.account_name = this.sendToAccount
                payload.account_handle = this.sendToAccount
                payload.image_url = null
                payload.verified = false
                // Email upload
                // payload.file_upload = this.$refs.fileUpload.checked
                payload.file_upload = false
            }
            else if (this.selectedAccount == 'random') {
                payload.account_name = this.queuedUser.account_name
                payload.account_handle = this.queuedUser.account_handle
                payload.image_url = this.queuedUser.image_url
                payload.verified = false
                this.queueUser()
            }
            else if (this.selectedAccount == 'custom') {
                payload.account_name = this.customName
                payload.account_handle = this.customHandle
                payload.verified = this.customVerified
            }
            else {
                const acct = accounts[this.selectedAccount]
                payload.account_name = acct.account_name
                payload.account_handle = acct.account_handle
                payload.image_url = acct.image_url
            }

            return payload

        },
        clearInput() {
            this.text = ""
            this.customName = ""
            this.customHandle = ""
        },
        sendMessage(pgroup_id = null, multiple = false) {
            if (this.gamemaster) {
                const payload = this.createPayload(pgroup_id)
                this.$socket.emit('sendPost', payload)
                if (!multiple) {
                    this.clearReplying()
                    this.clearInput()
                }
            }

            else {
                if (this.empty) return
                const text = this.replying_to ? '@' + this.replying_to_name + ' ' + this.text : this.text
                const payload = {
                    parent_post_id: this.replying_to,
                    project_id: this.curr_project,
                    instance_id: this.instance_id,
                    gamemaster_id: this.gamemaster_id,
                    text: text,
                    sender: 'participant',
                    account_name: this.pgroup_name,
                    account_handle: this.pgroup_name.replace(' ', '').toLowerCase(),
                    verified: true,
                    pgroup_id: pgroup_id ? pgroup_id : this.pgroup_id,
                    queued: false,
                    sent_to: this.sendToAccount,
                    type: this.media
                }
                this.text = ""
                this.clearReplying()
                this.$socket.emit('sendPost', payload)
            }
        },

        checkCustom() {
            if (this.selectedAccount == 'custom')
                this.customInput = true
            else
                this.customInput = false
            this.$emit('changedInput', this.selectedAccount)
            this.$emit('customInput', this.customInput)
        }
    }
}
</script>

<style>
.emailReceiver {
    display: flex;
    justify-content: flex-end;
    width: 100%;
}

#queueButton {
    margin-top: auto;
    margin-left: auto;
    margin-right: 0.2em;
    margin-bottom: 0.4em;
}

#selectAccount {
    display: flex;
    margin-bottom: 1em;
}

#composeContainer {
    margin-top: 1em;
}

#accountReplying {
    margin-left: auto;
    margin-top: 0.2em;
    margin-bottom: auto;
    font-size: 0.85em;
    display: flex;
}

#accountReplying:hover {
    cursor: pointer;
    text-decoration: line-through;
    text-decoration-color: #ed5338;
}

#sendToSelectText {
    margin: auto 1em auto auto;
    font-size: 0.9em;
    font-weight: bold;
}

#sendToSelect {
    height: 1.5em;
    margin: 0px;
    margin-top: auto;
    margin-bottom: auto;
    -webkit-appearance: checkbox;
    border-style: solid;
}

.userSelect {
    margin-left: auto;
    -webkit-appearance: checkbox;
    border-style: solid;
    padding: 0.2em;
}

.composeAvatar {
    margin-right: 0.5em;
    margin-top: 0.1em;
    height: 2em;
    width: 2em;
}
</style>